const CarModelList: readonly string[] = [
    'Arion',
    'Camry',
    'Corolla Axio',
    'Crown Athlete',
    'X7',
    'X8',
    'X6',
    'SAI',
    'Century',
    'Prius',
    'PHV',
    'Premio',
    'Bertha',
    'Mark X',
    '86',
    'Avensis',
    'X marks Geo',
    'Isis',
    'Alphard',
    'WISH',
    'VELLFIRE',
    'Voxy',
    'Estima',
    'Sienta',
    'Noah',
    'Hiace',
    'IQ',
    'Aqua',
    'ist',
    'Vitz',
    'Auris',
    'Passo',
    '6B',
    'Porte',
    'Lactis',
    'FJ Cruiser',
    'Harrier',
    'Land Cruiser'
];

export default CarModelList;